import axios from "../plugins/axios.plugin";

class DeliveryModeService {
  baseServicePath = "/api/delivery-mode";

  getAllDeliveryModes() {
    return axios.get(`${this.baseServicePath}/index?properties=1&page=1`);
  }
  filterDeliveryModes(payload, page) {
    return axios.post(
      `${this.baseServicePath}/filter/index?page=${page}`,
      payload
    );
  }
  filterPromoCodesNoPage(payload) {
    return axios.post(
      `${this.baseServicePath}/filter/index?pagination=0`,
      payload
    );
  }
  storeDeliveryMode(payload) {
    return axios.post(`${this.baseServicePath}/store`, payload);
  }
  searchDeliveryModes(payload) {
    return axios.post(`${this.baseServicePath}/search/index`, payload);
  }
  showADeliveryMode(payload) {
    return axios.get(`${this.baseServicePath}/show?id=${payload}&properties=1`);
  }
  editDeliveryMode(payload) {
    return axios.post(`${this.baseServicePath}/update`, payload);
  }
  deleteDeliveryMode(payload) {
    return axios.post(`${this.baseServicePath}/delete`, payload);
  }
}
export const deliveryModeService = new DeliveryModeService();
